import styles from './shell.module.css';

export interface ErrorScreenProps {
  readonly title?: string;
  readonly message?: string;
  /** Technical detail in English. Shown only in development builds. */
  readonly detail?: string | undefined;
  readonly onRetry?: (() => void) | undefined;
  readonly showDetail?: boolean;
}

/**
 * Full-screen error state. The Spanish copy never exposes internals; technical detail is
 * development-only, because the same screen renders for server and network failures.
 */
export function ErrorScreen({
  title = 'Algo salió mal',
  message = 'No se pudo mostrar esta pantalla. Revisa tu conexión e intenta de nuevo.',
  detail,
  onRetry,
  showDetail = import.meta.env.DEV,
}: ErrorScreenProps) {
  return (
    <div className={styles.screen} role="alert">
      <h1 className={styles.title}>{title}</h1>
      <p className={styles.message}>{message}</p>
      {onRetry ? (
        <button type="button" className={styles.action} onClick={onRetry}>
          Reintentar
        </button>
      ) : null}
      {showDetail && detail !== undefined && detail !== '' ? (
        <details className={styles.details}>
          <summary>Detalles técnicos</summary>
          <pre className={styles.detailsText}>{detail}</pre>
        </details>
      ) : null}
    </div>
  );
}
